import { render, staticRenderFns } from "./PortfolioTableHeader.vue?vue&type=template&id=9cd3e01c&scoped=true&"
import script from "./PortfolioTableHeader.vue?vue&type=script&lang=ts&"
export * from "./PortfolioTableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioTableHeader.vue?vue&type=style&index=0&id=9cd3e01c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd3e01c",
  null
  
)

export default component.exports